// extracted by mini-css-extract-plugin
module.exports = {"grid":"style__grid__lSMSG","toggle":"style__toggle__G9leX","wrapper":"style__wrapper__JCU-b","content":"style__content__AHLtf","button":"style__button__aWtmB"};